import api from "./api";

// Lead Gen API (/api/lead-gen). Every change is recorded with the editor's timezone, sent as x-tz.
export const LEAD_GEN_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
const headers = { "x-tz": LEAD_GEN_TZ };
const url = (path: string) => `/lead-gen${path}`;

export const leadGenApi = {
  get: <T>(path: string, params?: object) => api.get<T>(url(path), { params, headers }).then((r) => r.data),
  post: <T>(path: string, body?: unknown) => api.post<T>(url(path), body, { headers }).then((r) => r.data),
  put: <T>(path: string, body?: unknown) => api.put<T>(url(path), body, { headers }).then((r) => r.data),
  patch: <T>(path: string, body?: unknown) => api.patch<T>(url(path), body, { headers }).then((r) => r.data),
  delete: <T>(path: string, body?: unknown) => api.delete<T>(url(path), { data: body, headers }).then((r) => r.data),
  /** multipart upload (.eml files) */
  upload: <T>(path: string, form: FormData) =>
    api.post<T>(url(path), form, { headers: { ...headers, "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  /** a file the server builds (CSV export): saved under the name the server gives, else `fallback` */
  download: async (path: string, params: object | undefined, fallback: string) => {
    const r = await api.get<Blob>(url(path), { params, headers, responseType: "blob" });
    const name = /filename="?([^";]+)"?/.exec(String(r.headers["content-disposition"] ?? ""))?.[1] ?? fallback;
    const href = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = href;
    a.download = name;
    a.click();
    URL.revokeObjectURL(href);
  },
};

/** The message an API error carries (One Vertoz errors are { message }). */
export const leadGenError = (e: unknown, fallback = "Something went wrong.") =>
  (e as { response?: { data?: { message?: string } } })?.response?.data?.message || (e as Error)?.message || fallback;
